export const studentSessionAnalyticsHeader = [
  {
    headerName: 'Sl No.',
    field: 'sl_no',
    width: 100,
  },
  {
    headerName: 'Course Enrollment No',
    field: 'course_enrollment_id',
    width: 200,
  },
  {
    headerName: 'Admission No',
    field: 'admn_no',
    sortable: true,
    width: 180,
  },
  {
    headerName: 'Course Enrollment Date',
    field: 'course_enrollment_timestamp',
    sortable: true,
    width: 230,
  },
  {
    headerName: 'Name of student',
    field: 'student_name',
    sortable: true,
    width: 300,
    toolTipGetter: true,
  },
  {
    headerName: 'Project',
    field: 'project_name',
    width: 200,
    toolTipGetter: true,
  },
  {
    headerName: 'Class',
    field: 'class_name',
    sortable: true,
    width: 110,
  },
  {
    headerName: 'Course Enrolled',
    field: 'course_name',
    sortable: true,
    width: 300,
  },

  {
    headerName: 'SRO Remarks',
    field: 'sro_remarks',
    sortable: true,
    width: 200,
    toolTipGetter: true,
  },
  {
    headerName: 'CRO',
    field: 'cro_name',
    sortable: true,
    width: 300,
    toolTipGetter: true,
  },
  {
    headerName: 'CRO Remarks',
    field: 'cro_remarks',
    sortable: true,
    width: 200,
    toolTipGetter: true,
  },
  {
    headerName: 'Class Per Week',
    field: 'cro_class_per_week',
    sortable: true,
    width: 200,
  },
  {
    headerName: 'Fee Per Session',
    field: 'cro_fee_per_session',
    sortable: true,
    width: 200,
  },
  {
    headerName: 'Last Session Date',
    field: 'last_session_date',
    sortable: true,
    width: 200,
  },
  {
    headerName: 'Expected Sessions',
    field: 'exp_sessions',
    sortable: true,
    width: 200,
  },
  {
    headerName: '1st Week Sessions',
    field: 'first_week_session',
    sortable: true,
    width: 200,
  },
  {
    headerName: '2nd Week Sessions',
    field: 'second_week_session',
    sortable: true,
    width: 200,
  },
  {
    headerName: '3rd Week Sessions',
    field: 'third_week_session',
    sortable: true,
    width: 200,
  },
  {
    headerName: '4th Week Sessions',
    field: 'fourth_week_session',
    sortable: true,
    width: 200,
  },
  {
    headerName: 'Total Sessions',
    field: 'total_session',
    sortable: true,
    width: 200,
  },
  {
    headerName: 'SRO Sales Amount',
    field: 'total_sales_amount',
    sortable: true,
    width: 200,
  },
  {
    headerName: 'Total Fee Paid',
    field: 'total_fee_paid',
    sortable: true,
    width: 200,
  },
  {
    headerName: 'Balance',
    field: 'balance',
    width: 180,
  },
];
